// Added by Sejune Oh on 2019-08-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { action, makeObservable, observable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Root store
import Rootstore from '../../index'

// Store
import DataStorageStoreBase from '../../base/DataStorageStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface SeriesTagBaseElementProps {
  id?: string
  name?: string
  description?: string
  created_at?: string
  updated_at?: string
}

export interface SeriesTagElementProps extends SeriesTagBaseElementProps {}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class DataStorageSeriesTagStore extends DataStorageStoreBase<SeriesTagElementProps> {
  totalCount: number = 0
  elements: SeriesTagElementProps[] = []
  root?: Rootstore

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: Rootstore) {
    super({
      storeName: 'DS_SeriesTag',
      apiSubUrl: 'config/series-tags',
      _root: root,
    })
    this.root = root
    makeObservable(this, {
      totalCount: observable,
      elements: observable,
      _setTotalCount: action,
      setElements: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getElements = async (path: string) => {
    const rtnData = await super.getAll(path)
    await this._setTotalCount(parseInt(rtnData.total_count as string))
    return rtnData.items as Array<SeriesTagElementProps>
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  _setTotalCount = (count: number) => {
    this.totalCount = count
  }

  setElements = (elements: Array<SeriesTagElementProps>) => {
    this.elements = elements
  }
}
